import { MapPin, Clock } from "lucide-react";
import { EncabezadoSeccion, Reveal } from "../../shared/motion";
import Ornamento from "./Ornamento";

export default function Eventos({ datos, seccion }) {
  const eventos = datos.eventos || [];
  if (eventos.length === 0) return null;

  return (
    <section className="ba-seccion" aria-label={seccion.titulo}>
      <div className="ba-seccion-interior">
        <EncabezadoSeccion p="ba" etiqueta={seccion.etiqueta} titulo={seccion.titulo} centro testid="ba-titulo-eventos" />
        <div className="ba-eventos-lista">
          {eventos.map((ev, i) => (
            <Reveal key={ev.id || i} delay={i * 0.08}>
              <article className="ba-evento" data-testid={`ba-evento-${ev.id || i}`}>
                <p className="ba-evento-etiqueta">{ev.etiqueta}</p>
                <h3 className="ba-evento-nombre">{ev.lugar}</h3>
                <p className="ba-evento-hora">{ev.horario}</p>
                <p className="ba-evento-detalle">
                  <MapPin strokeWidth={1.5} />
                  <span>{ev.direccion}</span>
                </p>
                {ev.urlUbicacion && (
                  <a
                    className="ba-boton"
                    href={ev.urlUbicacion}
                    target="_blank"
                    rel="noopener noreferrer"
                    data-testid={`ba-boton-ubicacion-${ev.id || i}`}
                  >
                    <MapPin strokeWidth={1.5} />
                    {ev.textoBoton || "Cómo llegar"}
                  </a>
                )}
              </article>
              {i < eventos.length - 1 && (
                <div className="ba-eventos-divisor">
                  <Ornamento />
                </div>
              )}
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
